@if (reservation != null) {
<div [class]="'reservation d-flex flex-row justify-content-between ' + reservation.reservationDetails.reservationsStatus"
    [class.hidden]="reservationAssignTablesMode && assignTablesReservation?.reservationDetails?.reservationId != reservation.reservationDetails.reservationId"
    (click)="navigateToReservation()">

    <!-- status -->
    <div [canRead]="'Status'" class="reservation-status-container" (click)="onShowChangeStatusModal($event)">
        <!-- <app-icon [icon]="getStatusIcon()"></app-icon> -->
        <img [attr.src]="'assets/images/' + statusToIcon(reservation.reservationDetails.reservationsStatus)" class="status-icon">
    </div>

    <!-- details -->
    <div class="reservation-info w-100 p-1">

        <!-- customer name -->
        <span [canRead]="'FullName'" class="customer-name flex-font">
            {{getCustomerName()}}
        </span>

        <!-- customer type and tags -->
        <div class="d-flex flex-row align-items-center align-content-center">
            <span [canRead]="'Type'" [class]="'customer-type ' + (reservation.customerDetails.customerType ?? reservation.reservationDetails.reservationType)">
                {{reservation.customerDetails.customerType ?? reservation.reservationDetails.reservationType}}
            </span>
            <div [canRead]="'Tags'" class="customer-tags">
                @for (tagColor of reservation.customerDetails.customerTags | uniqueCustomerTagsCategories:tags; track $index) {
                    <span class="tag" [style.backgroundColor]="tagColor"></span>
                }
            </div>
        </div>

        <!-- arrivale & return time-->
        <div class="reservation-time flex-font">

            <div class="times d-flex flex-row">
                <div [canRead]="'ArrivalDateTime'">
                    @if (reservation.reservationDetails.expiredArrivalTime) {
                        <app-icon icon="LateArrival"></app-icon>
                    }
                    <span class="time arrival-time" [class.expired]="reservation.reservationDetails.expiredArrivalTime">{{reservation.reservationDetails.arrivalTime | amDateFormat:'HH:mm'}}</span>
                </div>
                <div [canRead]="'ReturnTime'">
                    @if (reservation.reservationDetails.expiredReturnTime) {
                        <app-icon icon="TimeReturn"></app-icon>
                    }
                    <span class="time return-time" [class.expired]="reservation.reservationDetails.expiredReturnTime">{{reservation.reservationDetails.returnTime | amDateFormat:'HH:mm'}}</span>
                </div>
            </div>

            <span [canRead]="'Covers'" class="covers">({{reservation.reservationDetails.covers}})</span>
        </div>

        <!-- reservation tags -->
        @if ((reservation.reservationDetails.allergy != null && reservation.reservationDetails.allergy.length > 0) 
            || (reservation.reservationDetails.reservationTags != null && reservation.reservationDetails.reservationTags.length > 0)) {
            <div [canRead]="'Tags'" class="reservation-tags">
                @if (reservation.reservationDetails.allergy != null && reservation.reservationDetails.allergy.length > 0) {
                    <app-icon icon="TagGroup"></app-icon>
                }
                @if (reservation.reservationDetails.reservationTags != null && reservation.reservationDetails.reservationTags.length > 0) {
                    <div class="tag-categories">
                        @for (tagColor of reservation.reservationDetails.reservationTags | uniqueReservationTagsCategories:tags; track $index) {
                            <app-icon class="reservation-tag" icon="ReservationTagArrowRight" [color]="tagColor"></app-icon>
                        }
                    </div>
                }
            </div>
        }

        <!-- reservation specific icons -->
        <div class="reservation-specific-icons">
            <!-- purpose food/drink -->
            @if (reservation.reservationDetails.purpose != null && reservation.reservationDetails.purpose !== 'Food') {
                <img [canRead]="'Purpose'" class="drink" src="assets/images/drinks.png">
            }
            <!-- smoking area -->
            @if (reservation.reservationDetails.smokingArea === true) {
                <!-- <app-icon icon="Smoking"></app-icon> -->
                <img [canRead]="'SmokingArea'" src="assets/images/smoking.png">
            }
            <!-- notes -->
            @if (reservation.reservationDetails.notes != null && reservation.reservationDetails.notes.length > 0) {
                <!-- <app-icon icon="Notes"></app-icon> -->
                <i [canRead]="'Notes'" class="ihost-icon-notes"></i>
            }
            <!-- discount -->
            @if (hasDiscount === true) {
                <!-- <app-icon icon="Discount"></app-icon> -->
                <small [canRead]="'Discount'" class="badge-discount">-{{reservation.reservationDetails.discount}}%</small>
            }
            <!-- source -->
            @if (hasSource && hasReadSourcePermission()) {
                @switch (reservation.sourceDetails?.sourceType) {
                    @case ("FACEBOOK") {
                        <!-- <app-icon icon="LogoFacebook"></app-icon> -->
                        <img src="assets/images/fb.png">
                    }
                    @case ("WEBSITE") {
                        <!-- <app-icon icon="LogoWeb"></app-icon> -->
                        <img src="assets/images/web.png">
                    }
                    @case ("INSTAGRAM") {
                        <!-- <app-icon icon="LogoInstagram"></app-icon> -->
                        <img src="assets/images/insta.png">
                    }
                    @case ("DINEATHENS") {
                        <!-- <app-icon icon="LogoDineathens"></app-icon> -->
                        <img src="assets/images/dine-athens.png">
                    }
                    @case ("GOOGLE") {
                        <!-- <app-icon icon="LogoGoogle"></app-icon> -->
                        <img src="assets/images/google.png">
                    }
                    @case ("HOTEL") {
                        <!-- <app-icon icon="LogoGodining"></app-icon> -->
                        <img src="assets/images/go.png">
                    }
                    @case ("GODINING") {
                        <!-- <app-icon icon="LogoGodining"></app-icon> -->
                        <img src="assets/images/go.png">
                    }
                    @case ("REFERENCE") {
                        <!-- <app-icon icon="User"></app-icon> -->
                        <img src="assets/images/ref.png">
                    }
                    @case ("MHOSPITALITY") {
                        <!-- <app-icon icon="LogoMhospitality"></app-icon> -->
                        <img src="assets/images/mobile-app.png">
                    }
                    @case ("TRIP_ADVISOR") {
                        <!-- <app-icon icon="LogoTripadvisor"></app-icon> -->
                        <img src="assets/images/trip_advisor.png">
                    }
                    @case ("RESY") {
                        <!-- <app-icon icon="LogoResy"></app-icon> -->
                        <img src="assets/images/resy.png">
                    }
                    @case ("MICHELIN") {
                        <!-- <app-icon icon="LogoMichelin"></app-icon> -->
                        <img src="assets/images/michelin.png">
                    }
                    @case ("AROUNDTHETABLE") {
                        <!-- <app-icon icon="LogoAroundthetable"></app-icon> -->
                        <img src="assets/images/around_the_table.png">
                    }
                    @case ("TRIPAROUND") {
                        <!-- <app-icon icon="LogoTriparound"></app-icon> -->
                        <img src="assets/images/triparound.png">
                    }
                    @case ("THELIST") {
                        <!-- <app-icon icon="LogoThelist"></app-icon> -->
                        <img src="assets/images/the_list.png">
                    }
                    @case ("TOPTOWN") {
                        <!-- <app-icon icon="LogoToptown"></app-icon> -->
                        <img src="assets/images/toptown.png">
                    }
                    @default {
                        @if (reservation.sourceDetails?.sourceCategory == 'EB2CPLATFORM' && reservation.sourceDetails?.sourceType != null) {
                            <span class="badge-unknown-source">{{reservation.sourceDetails?.sourceType | unknownSource}}</span>
                        }
                    }
                }
            }
            <!-- allergies -->
            @if (reservation.reservationDetails.allergy != null && reservation.reservationDetails.allergy != '' || dietaryTags.length > 0 || allergies.length > 0) {
                <!-- <app-icon icon="Allergies"></app-icon> -->
                <img [canRead]="'Allergies'" src="assets/images/icon_allergies.png" class="icon-dietary">
            }
            <!-- fixMenu -->
            @if (!restaurantHasExtraInfo && reservation.reservationDetails.fixMenu) {
                <!-- <app-icon icon="FixMenu"></app-icon> -->
                <img [canRead]="'FixMenu'" src="assets/images/fix-menu.png">
            }
            <!-- hasCake -->
            @if (reservation.reservationDetails.hasCake) {
                <!-- <app-icon icon="Cake"></app-icon> -->
                <img [canRead]="'Cake'" src="assets/images/icon_cake.png">
            }
            <!-- order -->
            @if (reservation.reservationDetails.preorder) {
                <img [canRead]="'PreOrder'" src="assets/images/preorder.png">
            }
            <!-- bill -->
            @if (reservation.reservationDetails.bill > 0) {
                <!-- <app-icon icon="Dollar"></app-icon> -->
                <small [canRead]="'Bill'" class="badge-bill">&euro;&euro;</small>
            }
            <!-- tokenization -->
            @if ((reservation.reservationDetails.bill == null || reservation.reservationDetails.bill <= 0) && reservation.reservationDetails.tokenization) {
                <!-- <app-icon icon="Tokenization"></app-icon> -->
                <img [canRead]="'Bill'" src="assets/images/credit-card.png">
            }
        </div>
    </div>

    <div class="table-info" (click)="setAssignMode($event)"
        [class.selected]="reservationAssignTablesMode && assignTablesReservation?.reservationDetails?.reservationId == reservation.reservationDetails.reservationId"
        [class.disabled]="!hasAssignTablesPermission()">

        @if (reservation.reservationDetails.allocatedTables != null && reservation.reservationDetails.allocatedTables.length > 0) {
            <a class="table-name flex-font">{{reservation.reservationDetails.allocatedTables | allocatedTableNames}}</a>
        } @else {
            @if (restaurantHasOnlineCategories 
                && reservation.reservationDetails.onlineCategory != null 
                && (reservation.reservationDetails.onlineCategory.id?.length ?? 0) > 0) {
                    <div class="online-category">
                        <label [style.background-color]="reservation.reservationDetails.onlineCategory.iconColor">
                            {{reservation.reservationDetails.onlineCategory.iconCaption}}
                        </label>
                    </div>
            }
        }

        <app-icon [canWrite]="'AssignTable'" icon="ArrowRight2"></app-icon>
    </div>
</div>
}